import { createContext } from "react";

const IsTermsPopUp= createContext()

export default IsTermsPopUp;